module.exports = __webpack_public_path__ + "static/media/camera-solid.b7bd37c4.svg";